<template>
  <div class="hsn-page-wrapper">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#9a6b27"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#1e293b" right :timeout="timeout">
      <div class="d-flex align-center justify-space-between text-white" style="font-size: 13px;">
        <span>{{ msg }}</span>
        <v-btn small icon text @click="showSnackBar = false" class="ml-2">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <!-- Top Executive Header Card -->
    <v-card flat class="header-card pa-4 mb-4 rounded-lg">
      <div class="d-flex flex-wrap align-center justify-space-between" style="gap: 16px;">
        <div class="d-flex align-center">
          <div class="header-icon-box mr-3">
            <v-icon color="#0f172a" size="22">mdi-file-document-outline</v-icon>
          </div>
          <div>
            <div class="page-title">HSN CODE LIST</div>
            <div class="page-subtitle">Manage HSN/SAC codes and GST slab rates used for billing</div>
          </div>
        </div>

        <v-btn
          dark
          color="#9a6b27"
          class="btn-primary text-capitalize elevation-1"
          @click="adddialog = true"
        >
          <v-icon left small>mdi-plus</v-icon>
          Add HSN
        </v-btn>
      </div>
    </v-card>

    <!-- Master Data Table Card -->
    <v-card flat class="content-table-card rounded-lg overflow-hidden">
      <div v-if="CodeList && CodeList.length > 0">
        <v-simple-table class="pro-master-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="width: 60px;">S.No.</th>
                <th class="text-left">Code</th>
                <th class="text-left">Name</th>
                <th class="text-left">Description</th>
                <th class="text-right" style="width: 120px;">Slab1 %</th>
                <th class="text-center" style="width: 100px;">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, i) in CodeList" :key="i" class="master-table-row">
                <td class="text-muted font-weight-medium">
                  {{ page == 1 ? i + 1 : i + 1 + 20 * (page - 1) }}
                </td>
                <td>
                  <span class="code-pill">{{ value.hsnCode || '—' }}</span>
                </td>
                <td class="font-weight-semibold" style="color: #0f172a;">
                  {{ value.name || '—' }}
                </td>
                <td class="text-muted">
                  {{ value.hsnDescription || '—' }}
                </td>
                <td class="text-right font-weight-semibold" style="color: #9a6b27;">
                  {{ value.gstSlab1Percentage !== undefined && value.gstSlab1Percentage !== null ? value.gstSlab1Percentage + '%' : '—' }}
                </td>
                <td class="text-center">
                  <div class="d-flex align-center justify-center" style="gap: 4px;">
                    <v-btn
                      icon
                      x-small
                      title="Edit HSN"
                      class="action-icon-btn"
                      @click="(dialogedit = true), (editItem = value)"
                    >
                      <v-icon size="16" color="#475569">mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      x-small
                      title="Delete HSN"
                      class="action-icon-btn delete-btn"
                      @click="(deletedialog = true), (DeleteId = value._id)"
                    >
                      <v-icon size="16" color="#dc2626">mdi-delete-outline</v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <!-- Pagination -->
        <div class="d-flex align-center justify-center px-4 py-3 border-t" v-if="Pagelength > 1">
          <v-pagination
            v-model="page"
            :length="Pagelength"
            total-visible="7"
            color="#9a6b27"
            class="pro-pagination"
          ></v-pagination>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else class="empty-state-wrap py-12 text-center">
        <div class="empty-icon-circle mb-3">
          <v-icon size="36" color="#94a3b8">mdi-file-document-outline</v-icon>
        </div>
        <div class="empty-title">No HSN codes found</div>
        <div class="empty-subtitle">
          No HSN/SAC codes have been added yet.
        </div>
        <div class="mt-4">
          <v-btn dark color="#9a6b27" class="btn-primary text-capitalize" @click="adddialog = true">
            <v-icon left small>mdi-plus</v-icon>
            Add First HSN
          </v-btn>
        </div>
      </div>
    </v-card>

    <!-- Delete Confirmation Dialog -->
    <v-dialog width="420px" v-model="deletedialog">
      <v-card class="modal-card rounded-lg overflow-hidden pa-4">
        <div class="text-center py-3">
          <div class="delete-icon-box mx-auto mb-3">
            <v-icon size="32" color="#dc2626">mdi-trash-can-outline</v-icon>
          </div>
          <div class="delete-title mb-1">Delete HSN Code</div>
          <div class="delete-subtitle px-4">
            Are you sure you want to delete this HSN code? This action cannot be undone.
          </div>
        </div>

        <div class="d-flex align-center justify-center mt-4" style="gap: 12px;">
          <v-btn
            outlined
            color="#64748b"
            class="text-capitalize"
            style="border-radius: 8px;"
            @click="deletedialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            dark
            color="#dc2626"
            class="text-capitalize elevation-1"
            style="border-radius: 8px;"
            @click="deleteHSNCode(DeleteId)"
          >
            Confirm Delete
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Add HSN Dialog -->
    <v-dialog width="640px" v-model="adddialog" persistent>
      <v-form v-model="addcat" ref="addcat" @submit.prevent>
        <v-card class="modal-card rounded-lg overflow-hidden">
          <div class="modal-header d-flex align-center justify-space-between px-6 py-4">
            <div class="d-flex align-center">
              <v-icon color="#9a6b27" class="mr-2">mdi-file-document-plus-outline</v-icon>
              <div>
                <div class="modal-title">Add New HSN</div>
                <div class="modal-subtitle">Create a new HSN/SAC code with its GST slab rate</div>
              </div>
            </div>
            <v-btn icon small @click="(adddialog = false); resetForm()">
              <v-icon color="#64748b">mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="modal-body px-6 py-4">
            <v-row dense>
              <v-col cols="12" sm="6">
                <label class="field-label">HSN Code <span class="required-star">*</span></label>
                <v-text-field
                  :rules="[rules.required]"
                  type="text"
                  placeholder="e.g. 7113"
                  v-model="newHSNcode"
                  outlined
                  dense
                  color="#9a6b27"
                  class="pro-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="field-label">Name <span class="required-star">*</span></label>
                <v-text-field
                  :rules="[rules.required]"
                  type="text"
                  placeholder="Enter HSN name"
                  v-model="newHSNname"
                  outlined
                  dense
                  color="#9a6b27"
                  class="pro-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="field-label">Slab Percentage <span class="required-star">*</span></label>
                <v-text-field
                  :rules="[rules.required]"
                  type="number"
                  placeholder="e.g. 5"
                  v-model="newHSNpercent"
                  outlined
                  dense
                  color="#9a6b27"
                  class="pro-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label class="field-label">Description</label>
                <v-textarea
                  type="text"
                  placeholder="Optional description"
                  v-model="newHSNdescription"
                  outlined
                  dense
                  rows="2"
                  color="#9a6b27"
                  class="pro-input"
                  hide-details="auto"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>

          <div class="modal-footer d-flex align-center justify-end px-6 py-3 border-t">
            <v-btn text class="btn-cancel text-capitalize mr-2" @click="(adddialog = false); resetForm()">
              Cancel
            </v-btn>
            <v-btn dark color="#9a6b27" class="btn-primary text-capitalize elevation-1" @click="AddHsn()">
              <v-icon left small>mdi-check</v-icon>
              Add HSN
            </v-btn>
          </div>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Edit HSN Dialog -->
    <v-dialog width="640px" v-model="dialogedit" persistent>
      <v-form v-model="addcat" ref="addcat" @submit.prevent>
        <v-card class="modal-card rounded-lg overflow-hidden" v-if="editItem">
          <div class="modal-header d-flex align-center justify-space-between px-6 py-4">
            <div class="d-flex align-center">
              <v-icon color="#9a6b27" class="mr-2">mdi-pencil-box-outline</v-icon>
              <div>
                <div class="modal-title">Edit HSN</div>
                <div class="modal-subtitle">Update HSN code details or GST slab rate</div>
              </div>
            </div>
            <v-btn icon small @click="dialogedit = false">
              <v-icon color="#64748b">mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="modal-body px-6 py-4">
            <v-row dense>
              <v-col cols="12" sm="6">
                <label class="field-label">HSN Code <span class="required-star">*</span></label>
                <v-text-field
                  :rules="[rules.required]"
                  type="text"
                  v-model="editItem.hsnCode"
                  outlined
                  dense
                  color="#9a6b27"
                  class="pro-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="field-label">Name <span class="required-star">*</span></label>
                <v-text-field
                  :rules="[rules.required]"
                  type="text"
                  placeholder="Enter HSN name"
                  v-model="editItem.name"
                  outlined
                  dense
                  color="#9a6b27"
                  class="pro-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label class="field-label">Slab Percentage <span class="required-star">*</span></label>
                <v-text-field
                  :rules="[rules.required]"
                  type="number"
                  v-model="editItem.gstSlab1Percentage"
                  outlined
                  dense
                  color="#9a6b27"
                  class="pro-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label class="field-label">Description</label>
                <v-textarea
                  type="text"
                  v-model="editItem.hsnDescription"
                  outlined
                  dense
                  rows="2"
                  color="#9a6b27"
                  class="pro-input"
                  hide-details="auto"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>

          <div class="modal-footer d-flex align-center justify-end px-6 py-3 border-t">
            <v-btn text class="btn-cancel text-capitalize mr-2" @click="dialogedit = false">
              Cancel
            </v-btn>
            <v-btn dark color="#9a6b27" class="btn-primary text-capitalize elevation-1" @click="editHsn()">
              <v-icon left small>mdi-content-save-outline</v-icon>
              Save Changes
            </v-btn>
          </div>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      deletedialog: false,
      DeleteId: null,
      editItem: {},
      showSnackBar: false,
      ServerError: false,
      appLoading: false,
      CodeList: [],
      newHSNpercent: null,
      newHSNcode: null,
      newHSNname: null,
      newHSNdescription: null,
      page: 1,
      Pagelength: 1,
      currentPage: 1,
      adddialog: false,
      dialogedit: false,
      msg: null,
      timeout: 2500,

      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      curItem: {
        gstSlab2Percentage: 0,
        gstSlab2MinimumPrice: 0,
      },
    };
  },

  watch: {
    page() {
      this.getData();
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    resetForm() {
      this.newHSNpercent = null;
      this.newHSNcode = null;
      this.newHSNname = null;
      this.newHSNdescription = null;
      if (this.$refs.addcat) {
        this.$refs.addcat.resetValidation();
      }
    },
    deleteHSNCode(id) {
      axios({
        url: "/hsncode/delete/" + id,
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.deletedialog = false;
            this.msg = response.data.msg;
            this.DeleteId = 0;
            this.appLoading = false;
            this.getData();
          } else {
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    AddHsn() {
      this.appLoading = true;
      axios({
        url: "/hsncode/add",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.newHSNname,
          hsnCode: this.newHSNcode,
          hsnDescription: this.newHSNdescription,
          gstSlab1Percentage: this.newHSNpercent,
        },
      })
        .then((response) => {
          this.showSnackBar = true;
          this.adddialog = false;
          this.msg = response.data.msg;
          this.resetForm();
          this.appLoading = false;
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/hsnCodes/list",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          limit: 50,
          searchKeyword: "",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.CodeList = response.data.data;
          this.Pagelength = Math.ceil(response.data.totalLength / 50) || 1;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editHsn() {
      axios({
        url: "/hsncode/edit",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editItem._id,
          hsnCode: this.editItem.hsnCode,
          name: this.editItem.name,
          hsnDescription: this.editItem.hsnDescription,
          gstSlab1Percentage: this.editItem.gstSlab1Percentage,
        },
      })
        .then((response) => {
          this.dialogedit = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap");

.hsn-page-wrapper {
  padding: 4px 0 40px 0;
  width: 100%;
  margin: 0 auto;
  font-family: "Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #0f172a;
}

.header-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;
}

.header-icon-box {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.5px;
}

.page-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 1px;
}

.btn-primary {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  height: 38px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.2s ease !important;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px);
}

/* Master Data Table Card */
.content-table-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;
}

.pro-master-table table {
  width: 100%;
  border-collapse: collapse;
}

.pro-master-table th {
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  padding: 12px 16px !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.pro-master-table td {
  font-size: 13px !important;
  color: #334155 !important;
  padding: 12px 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.master-table-row:hover {
  background-color: #f8fafc !important;
}

.code-pill {
  font-family: monospace;
  font-weight: 600;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11.5px;
  color: #1e293b;
}

.action-icon-btn {
  border: 1px solid #e2e8f0 !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  width: 30px !important;
  height: 30px !important;
}

.action-icon-btn:hover {
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

.action-icon-btn.delete-btn:hover {
  background: #fef2f2 !important;
  border-color: #fca5a5 !important;
}

.border-t {
  border-top: 1px solid #f1f5f9;
}

.text-muted {
  color: #94a3b8;
}

/* Empty State */
.empty-state-wrap {
  padding: 60px 20px;
}

.empty-icon-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.empty-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.empty-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 4px;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

/* Modal Dialogs */
.modal-card {
  background: #ffffff !important;
}

.modal-header {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.modal-subtitle {
  font-size: 12px;
  color: #64748b;
}

.field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 4px;
}

.required-star {
  color: #dc2626;
}

.pro-input :deep(.v-input__slot) {
  min-height: 38px !important;
  border-radius: 6px !important;
  font-size: 13px !important;
}

.pro-input :deep(fieldset) {
  border-color: #cbd5e1 !important;
}

.pro-input.v-input--is-focused :deep(fieldset) {
  border-color: #9a6b27 !important;
}

.btn-cancel {
  border-radius: 8px !important;
  color: #64748b !important;
  font-weight: 600 !important;
  font-size: 12px !important;
}

.delete-icon-box {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #fef2f2;
  border: 1px solid #fecaca;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.delete-subtitle {
  font-size: 12.5px;
  color: #64748b;
  line-height: 1.5;
}
</style>
